import Select from "@/components/base/Select";
import { ORDER_STATUS_CONFIG } from "@/constants/status";
import type { OrderStatus } from "@/types";

const FILTER_KEYS: (OrderStatus | "all")[] = [
  "all",
  "new",
  "preparing",
  "almost",
  "ready",
  "outForDelivery",
  "received",
  "missed",
];

interface OrderFiltersProps {
  filter: OrderStatus | "all";
  counts: Record<string, number>;
  onFilterChange: (value: OrderStatus | "all") => void;
  query: string;
  onQueryChange: (value: string) => void;
  branch: string;
  onBranchChange: (value: string) => void;
  branchOptions: string[];
}

export default function OrderFilters({
  filter,
  counts,
  onFilterChange,
  query,
  onQueryChange,
  branch,
  onBranchChange,
  branchOptions,
}: OrderFiltersProps) {
  const branchSelectOptions = [
    { value: "all", label: "كل الفروع" },
    ...branchOptions.map((item) => ({ value: item, label: item })),
  ];

  return (
    <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
      <div className="flex flex-wrap gap-2">
        {FILTER_KEYS.map((key) => {
          const active = filter === key;
          const label =
            key === "all" ? "الكل" : ORDER_STATUS_CONFIG[key].label;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onFilterChange(key)}
              className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-white"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {label}
              <span
                className={`rounded-full px-1.5 text-[11px] font-bold ${
                  active
                    ? "bg-white/25 text-white"
                    : "bg-white text-foreground-500"
                }`}
              >
                {counts[key] ?? 0}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex items-center rounded-btn border border-background-200 bg-white px-3 focus-within:ring-2 focus-within:ring-primary-300">
          <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
            <i className="ri-search-line"></i>
          </span>
          <input
            type="text"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="ابحث برقم الطلب أو اسم العميل"
            className="w-full sm:w-60 h-11 bg-transparent px-2 text-sm outline-none placeholder:text-foreground-300"
          />
        </div>

        <Select
          value={branch}
          options={branchSelectOptions}
          onChange={onBranchChange}
          icon="ri-store-2-line"
          ariaLabel="تصفية حسب الفرع"
          className="w-full sm:w-48"
        />
      </div>
    </div>
  );
}